import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/flash-sale/ClientPage.tsx");
